import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="edit-item"
export default class extends Controller {
  static targets = [
    "itemLink",
    "authLicensee",
    "federations",
    "federationsCheckboxes",
    "authGender",
    "bibsForm",
    "clubName",
    "clubNameMandatory",
    "checkbox",
    "checkedFederationsList",
    "siffa",
    "siffaInput",
    "siffaResult",
    "additionalFieldFields",
    "participantNumbering",
    "documentTypeCheckbox",
    "languagesInput",
    "coachesInput",
    "levelsInput",
    "zonesInput",
    "nameInput",
    "participantMaxInput",
    "bookableInput",
    "defaultDelay",
    "inputBeginDate",
    "inputEndDate",
  ];
  static values = { page: String, price: String, defaultDelay: Number, maxDelay: Number };

  declare itemLinkTargets: HTMLElement[];
  declare hasItemLinkTarget: boolean;
  declare pageValue: string;
  declare hasPriceValue: boolean;
  declare priceValue: string;
  // genre
  declare authGenderTargets: HTMLInputElement[];
  declare hasAuthGenderTarget: boolean;
  // dossards
  declare bibsFormTarget: HTMLElement;
  declare hasBibsFormTarget: boolean;
  declare participantNumberingTargets: HTMLInputElement[];
  declare hasParticipantNumberingTarget: boolean;
  // licenciés
  declare authLicenseeTargets: HTMLInputElement[];
  declare hasAuthLicenseeTarget: boolean;
  //fédérations
  declare federationsTarget: HTMLElement;
  declare hasFederationsTarget: boolean;
  declare federationsCheckboxesTarget: HTMLElement;
  declare hasFederationsCheckboxesTarget: boolean;
  declare checkboxTargets: HTMLInputElement[];
  declare hasCheckboxTarget: HTMLInputElement[];
  declare checkedFederationsListTarget: HTMLElement;
  declare hasCheckedFederationsListTarget: boolean;
  declare siffaTarget: HTMLElement;
  declare hasSiffaTarget: boolean;
  declare siffaInputTarget: HTMLInputElement;
  declare hasSiffaInputTarget: boolean;
  declare siffaResultTarget: HTMLElement;
  declare hasSiffaResultTarget: boolean;
  //items/champs additionnels
  declare clubNameTarget: HTMLInputElement;
  declare hasClubNameTarget: boolean;
  declare clubNameMandatoryTarget: HTMLInputElement;
  declare hasClubNameMandatoryTarget: boolean;
  declare additionalFieldFieldsTargets: HTMLElement[];
  declare hasAdditionalFieldFieldsTarget: boolean;
  // documents
  declare documentTypeCheckboxTargets: HTMLInputElement[];
  declare hasDocumentTypeCheckboxTarget: boolean;
  // créneaux
  declare coachesInputTargets: HTMLInputElement[];
  declare hasCoachesInputTarget: boolean;
  declare levelsInputTargets: HTMLInputElement[];
  declare hasLevelsInputTarget: boolean;
  declare languagesInputTargets: HTMLInputElement[];
  declare hasLanguagesInputTarget: boolean;
  declare zonesInputTargets: HTMLInputElement[];
  declare hasZonesInputTarget: boolean;
  declare nameInputTarget: HTMLInputElement;
  declare hasNameInputTarget: boolean;
  declare participantMaxInputTarget: HTMLInputElement;
  declare hasParticipantMaxInputTarget: boolean;
  declare bookableInputTargets: HTMLInputElement[];
  declare hasBookableInputTarget: boolean;
  declare inputBeginDateTarget: HTMLInputElement;
  declare hasInputBeginDateTarget: boolean;
  declare inputEndDateTarget: HTMLInputElement;
  declare hasInputEndDateTarget: boolean;
  declare defaultDelayValue: number;
  declare hasDefaultDelayValue: boolean;
  declare maxDelayValue: number;
  declare hasMaxDelayValue: boolean;

  additionalFieldsForm = null;

  connect() {
    this.selectedTabs();
    this.toggleLicensee();
    this.toggleClubNameMandatory();
    this.displayCheckedFederations();
    this.displaySiffaInput();
    if (this.hasAdditionalFieldFieldsTarget) {
      this.additionalFieldsForm = this.additionalFieldFieldsTargets[0].outerHTML;
      this.hideEmptyAddFieldsForm();
    }
    setTimeout(() => {
      this.scrollToPrice();
    }, 500);
    if (this.hasParticipantNumberingTarget) {
      this.bibs();
    }
  }

  selectedTabs() {
    if (this.hasItemLinkTarget) {
      for (let link of this.itemLinkTargets) {
        let pageLink = link.getAttribute("href");
        if (pageLink.includes(this.pageValue)) {
          link.className = "tab-selected";
        } else {
          link.className = "tab";
        }
      }
    }
  }

  bibs() {
    if (this.hasParticipantNumberingTarget && this.hasBibsFormTarget) {
      let selectedValue = this.participantNumberingTargets.find((input) => input.checked)?.value;
      if (selectedValue == "range") {
        this.bibsFormTarget.classList.remove("hidden");
      } else {
        this.bibsFormTarget.classList.add("hidden");
      }
    }
  }

  toggleLicensee() {
    if (this.hasAuthLicenseeTarget && this.hasFederationsTarget) {
      for (let radioBtn of this.authLicenseeTargets) {
        if (radioBtn.checked) {
          if (radioBtn.value == "no-validation" || radioBtn.value == "unlicensed") {
            this.hideElt(this.federationsTarget);
          } else {
            this.displayElt(this.federationsTarget);
          }
        }
      }
    }
  }
  toggleFederationsCb() {
    if (this.hasFederationsTarget && this.hasFederationsCheckboxesTarget) {
      this.federationsCheckboxesTarget.classList.toggle("hidden");
    }
  }

  toggleClubNameMandatory() {
    if (this.hasClubNameTarget && this.hasClubNameMandatoryTarget) {
      if (this.clubNameTarget.checked) {
        this.displayElt(this.clubNameMandatoryTarget);
      } else {
        this.hideElt(this.clubNameMandatoryTarget);
      }
    }
  }

  displayElt(elt: HTMLElement) {
    if (elt.classList.contains("hidden")) {
      elt.classList.remove("hidden");
    }
  }

  hideElt(elt: HTMLElement) {
    if (!elt.classList.contains("hidden")) {
      elt.classList.add("hidden");
    }
  }

  displayCheckedFederations() {
    if (this.hasCheckedFederationsListTarget) {
      let list = this.checkedFederationsListTarget.innerText.split(", ");
      this.displaySiffaInput();
      for (let cb of this.checkboxTargets) {
        let federationName = cb.labels[0].innerText;
        if (cb.checked && !list.includes(federationName)) {
          list.push(federationName);
        } else if (!cb.checked && list.includes(federationName))
          list = list.filter((name) => {
            return name != federationName;
          });
      }
      this.checkedFederationsListTarget.innerText = list
        .filter((name) => {
          return name != "";
        })
        .join(", ");
    }
  }

  filterFederations(event) {
    if (this.hasFederationsCheckboxesTarget) {
      let inputsCb = this.federationsCheckboxesTarget.getElementsByTagName("input");
      const search = event.target.value;
      for (let cb of inputsCb) {
        if (cb.type == "checkbox" && cb.labels && search.trim() != "") {
          const label = cb.labels[0].innerText;
          if (label.toLowerCase().includes(search.toLowerCase())) {
            cb.parentElement?.classList.remove("hidden");
          } else {
            cb.parentElement?.classList.add("hidden");
          }
        } else {
          cb.parentElement?.classList.remove("hidden");
        }
      }
    }
  }

  displaySiffaInput() {
    if (this.hasSiffaTarget) {
      let ffa = document.getElementById("item_federation_ids_1");
      if (ffa.checked) {
        this.displayElt(this.siffaTarget);
      } else {
        this.hideElt(this.siffaTarget);
      }
    }
  }

  addAdditionalField() {
    let index = 0;
    if (this.hasAdditionalFieldFieldsTarget) {
      let indexes = [];
      for (let div of this.additionalFieldFieldsTargets) {
        indexes.push(parseInt(div.dataset.index));
      }
      index = this.additionalFieldFieldsTargets.length;
      while (indexes.includes(index)) {
        index++;
      }
    }
    if (this.hasAdditionalFieldFieldsTarget || this.additionalFieldsForm != null) {
      let text = this.additionalFieldsForm.replaceAll(/fields_attributes_\d{1,3}/g, `fields_attributes_${index}`);
      text = text.replaceAll(
        /item\[additional_fields_attributes\]\[\d{1,3}\]/g,
        `item[additional_fields_attributes][${index}]`,
      );
      text = text.replaceAll(/data-index="\d{1,3}\"/g, `data-index="${index}"`);
      document.getElementById("additional_fields").insertAdjacentHTML("beforeend", text);
      document.getElementById(`item_additional_fields_attributes_${index}_label`).value = null;
    }
  }

  removeAdditionalField(event) {
    if (event.target.parentElement.parentElement.parentElement.hasAttribute("data-edit-item-target")) {
      event.target.parentElement.parentElement.parentElement.remove();
    }
  }

  hideEmptyAddFieldsForm() {
    if (this.hasAdditionalFieldFieldsTarget && this.additionalFieldFieldsTargets.length == 1) {
      let index = parseInt(this.additionalFieldFieldsTargets[0].dataset.index);
      let inputLabel = document.getElementById(`item_additional_fields_attributes_${index}_label`);
      if (inputLabel.value.trim() == "") {
        this.hideElt(this.additionalFieldFieldsTargets[0]);
      }
    }
  }

  removeHiddenForm() {
    if (this.hasAdditionalFieldFieldsTarget && this.additionalFieldFieldsTargets[0].classList.contains("hidden")) {
      this.additionalFieldFieldsTargets[0].remove();
    }
  }

  scrollToPrice() {
    if (this.hasPriceValue && this.priceValue != "0") {
      const priceTarget = document.getElementById(`price-${this.priceValue}`);
      if (priceTarget) {
        priceTarget.scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  checkCertificates(event) {
    if (this.hasDocumentTypeCheckboxTarget && event.target.checked && ["2", "13", "14"].includes(event.target.value)) {
      const certif2 = this.documentTypeCheckboxTargets.find((cb) => cb.value == "2");
      const certif14 = this.documentTypeCheckboxTargets.find((cb) => cb.value == "14");
      const certif13 = this.documentTypeCheckboxTargets.find((cb) => cb.value == "13");
      let other_certifs: (HTMLInputElement | undefined)[] = [];

      if (event.target.value == "2") {
        other_certifs = [certif14, certif13];
      } else if (event.target.value == "14") {
        other_certifs = [certif2, certif13];
      } else if (event.target.value == "13") {
        other_certifs = [certif2, certif14];
      }
      other_certifs.forEach((cb) => {
        if (cb) {
          cb.checked = false;
        }
      });
    }
  }

  calculateAge(event) {
    let hint = event.target.parentElement.nextSibling;
    if (event.target.value != "" && !event.target.value.startsWith("0")) {
      const inputDate = Date.parse(event.target.value);
      const baseDate = Date.parse(event.target.dataset.date.replaceAll('"', ""));
      let diff = (baseDate - inputDate) / (1000 * 60 * 60 * 24 * 365.25);
      hint.innerText += ` (${Math.floor(diff)} ans)`;
    } else {
      hint.innerText = hint.innerText.split(" (")[0];
    }
  }

  async checkSiffa(event) {
    const spinner = document.getElementById("spinner");
    if (spinner) {
      spinner.classList.remove("hidden");
    }
    const params = {
      siffa: this.siffaInputTarget.value,
    };
    fetch(`check_siffa/`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
      body: JSON.stringify(params),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((json) => {
        const spinner = document.getElementById("spinner");
        if (spinner) {
          spinner.classList.add("hidden");
        }
        if (json && json.valid) {
          this.siffaResultTarget.className = "success-infos";
          this.siffaResultTarget.innerText = "Code SIFFA valide";
        } else {
          this.siffaResultTarget.className = "error-infos";
          if (json && json.error) {
            this.siffaResultTarget.innerText = json.error;
          } else {
            this.siffaResultTarget.innerText = "Une erreur est survenue. La vérification est impossible pour le moment";
          }
        }
      });
  }

  // Récupère les infos de l'activité pour remplir les infos par défaut du créneau -> Spécifique Vélodrome
  async setSlotDefault(event) {
    const itemId = event.target.value;
    if (!itemId) {
      return;
    }
    const spinner = document.getElementById("spinner");
    if (spinner) {
      spinner.classList.remove("hidden");
    }
    fetch(`/ik_admin/items/${itemId}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((json) => {
        const spinner = document.getElementById("spinner");
        if (spinner) {
          spinner.classList.add("hidden");
        }
        if (json) {
          if (this.hasNameInputTarget) {
            this.nameInputTarget.placeholder = json.name;
          }
          if (this.hasParticipantMaxInputTarget) {
            this.participantMaxInputTarget.value = json.participant_max;
          }
          if (this.hasCoachesInputTarget) {
            let coaches = json.coaches == null ? [] : json.coaches;
            this.coachesInputTargets.forEach((cb) => {
              cb.checked = coaches.includes(Number.parseInt(cb.value));
            });
          }
          if (this.hasLevelsInputTarget) {
            let levels = json.levels == null ? [] : json.levels;
            this.levelsInputTargets.forEach((cb) => {
              cb.checked = levels.includes(Number.parseInt(cb.value));
            });
          }
          if (this.hasZonesInputTarget) {
            let zones = json.zones == null ? [] : json.zones;
            this.zonesInputTargets.forEach((cb) => {
              cb.checked = zones.includes(Number.parseInt(cb.value));
            });
          }
          if (this.hasLanguagesInputTarget) {
            let languages = json.languages == null ? [] : json.languages;
            this.languagesInputTargets.forEach((cb) => {
              cb.checked = languages.includes(Number.parseInt(cb.value));
            });
          }
          if (this.hasBookableInputTarget) {
            let bookable = json.bookable == null ? "true" : `${json.bookable}`;
            let button = this.bookableInputTargets.find((b) => b.value == bookable);
            if (button) {
              button.checked = true;
            }
          }
          this.defaultDelayValue = json.duration == null ? 0 : json.duration;
        }
      });
  }

  fillEndDate() {
    if (this.hasInputBeginDateTarget && this.hasInputEndDateTarget && this.inputBeginDateTarget.value != "") {
      const regexDate = /^\d{4}-\d{2}-\d{2}$/;
      const regexTime = /^\d{2}:\d{2}$/;
      let value = this.inputBeginDateTarget.value;
      // format date yyyy-mm-dd
      if (regexDate.test(value)) {
        let newValue = new Date(value);
        newValue.setTime(newValue.getTime() + (this.hasDefaultDelayValue ? this.defaultDelayValue * 1000 : 0));
        this.inputEndDateTarget.value = newValue.toISOString().slice(0, 10);
        if (this.hasMaxDelayValue) {
          let maxValue = new Date(value);
          maxValue.setTime(maxValue.getTime() + this.maxDelayValue * 1000);
          this.inputEndDateTarget.max = maxValue.toISOString().slice(0, 10);
        }
      } else if (regexTime.test(value)) {
        const [h, m] = value.split(":").map(Number);
        // convertir en minutes depuis minuit
        let totalMinutes = h * 60 + m + (this.hasDefaultDelayValue ? this.defaultDelayValue : 0);
        // gérer le dépassement de minuit (24h)
        totalMinutes = totalMinutes % (24 * 60);
        const newH = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
        const newM = String(totalMinutes % 60).padStart(2, "0");
        this.inputEndDateTarget.value = `${newH}:${newM}`;
      }
    }
  }
}
